module.exports = __webpack_public_path__ + "img/logo.d12c8230.png";